module.exports = __webpack_public_path__ + "img/cooperation.a00ad33c.png";